(function () {
  const sections = document.querySelectorAll("[data-faq-section]");
  if (!sections.length) return;

  sections.forEach((section) => {
    const allowMultiple = section.dataset.faqMultiple === "true";
    const openFirst = section.dataset.faqOpenFirst === "true";

    const items = Array.from(section.querySelectorAll("[data-faq-item]"));
    const toggles = Array.from(section.querySelectorAll("[data-faq-toggle]"));

    function closeItem(btn) {
      const panelId = btn.getAttribute("aria-controls");
      const panel = panelId ? section.querySelector("#" + CSS.escape(panelId)) : null;

      btn.setAttribute("aria-expanded", "false");
      if (panel) panel.hidden = true;
    }

    function openItem(btn) {
      const panelId = btn.getAttribute("aria-controls");
      const panel = panelId ? section.querySelector("#" + CSS.escape(panelId)) : null;

      btn.setAttribute("aria-expanded", "true");
      if (panel) panel.hidden = false;
    }

    function toggle(btn) {
      const expanded = btn.getAttribute("aria-expanded") === "true";

      if (!allowMultiple) {
        toggles.forEach((b) => {
          if (b !== btn) closeItem(b);
        });
      }

      if (expanded) closeItem(btn);
      else openItem(btn);
    }

    toggles.forEach((btn) => {
      btn.addEventListener("click", () => toggle(btn));
    });

    if (openFirst && toggles[0]) {
      openItem(toggles[0]);
    }
  });
})();
